export var shouldSample = function shouldSample() {
  var threshold = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
  return Math.random() > threshold;
};